import actions from '../actionTypes';
import UndoManager from '../../utilities/UndoManager/undomanager';
import * as Constants from '../../utilities/constants/Constants';

const initialState = {
  activeObject: null,
  previousActiveObject: null,
  activeSelection: null,
  selectedObjects: [],
  renderFlag: false,
  wallCanvas: null,
  roomCanvas: null,
  draggableModalPosition: { x: 0, y: 0 },
  draggableToolPosition: { x: null, y: null },
  rotateModalValue: 0,
  scalarModalValue: 0.0,
  transparencyModalValue: 0.0,
  bottomBarStatus: { 1: 'active', 2: 'nohover', 3: 'nohover' },
  loadingState: null,
  loadingCount: 0,
  dimensions: {
    orgWindowWidth: null,
    orgWindowHeight: null,
    windowWidth: null,
    windowHeight: null,
    canvasWallScaleWidth: null,
    canvasWallScaleHeight: null,
    projectScaleWidth: null,
    projectScaleHeight: null
  },
  undoInstance: new UndoManager(),
  triggerProjectDirty: false,
  draggedPosition: {
    left: 0,
    top: 0,
    angle: 0,
    scaleX: 0,
    scaleY: 0,
    scaleSlider: 0,
    object: null
  },
  showPixelationWarningField: false,
  nonPixelatedDimension: { width: 0, height: 0 },
  setInitialPixelationShown: false,
  showPixelationWindowDialogue: false,
  showRequestSampleWindow: false,
  showOrderSampleDetailsWindow: false,
  orderSampleDetails: { lastX: 0, lastY: 0 },
  sendPreviewWithLoupe: false,
  shareLinkType: 'View',
  draggedElement: null,
  helpWindowIsVisible: false,
  handleHelpCheckBox: true,
  selectedTool: null,
  filteredTools: [],
  isGrouped: false,
  webLinkSaveDialogue: false,
  selectedFolderForWebLink: '',
  webUserInfo: null,
  vanillaLoginIsOpen: false,
  dialogueParams: {
    dialogueTitle: '',
    dialogueDescription: '',
    color: 'black',
    onclick: null,
    onCancel: null,
    buttonTitles: {},
    dialogueFlag: false
  },
  webLinkSaveFolderType: '',
  allExternalProjects: [],
  rootFolders: [],
  isWebLinkFirstSave: true,
  webLinkSaveIdentifier: '',
  isSaveViaWallNavigation: false,
  shareMedium: null,
  showIframe: false,
  defaultMaskStepForOrderSample: 0,
  makeProjectDirtyWithNoUndoSupport: false,
  redrawCanvas: false,
  showFeedbackDialogue: false,
  feedbackState: true,
  projectSubmissionState: Constants.PROJECT_SUBMISSION_STATE.DONT_SUBMIT_STATE,
  zoomState: false,
  zoomInState: false,
  zoomOutState: false,
  viewType: null,
  is3DViewLoaded: false,
  initialLoader: false,
  refresh3D: false,
  feedbackRating: '',
  feedbackReview: null,
  feedbackPermission: false,
  svgReferenceId: null,
  sendReviewGA: true,
  blockChainTransactionInProgress: false,
  showTemplateSelectionDialogue: false,
  dataPriorToTemplateSelection: null,
  sharedSceneData: {
    sharedScenePlacing: null,
    sharedSceneProjectIndex: 0
  },
  projectGroupSharedScene: false,
  draggableCanvasPosition: { x: -1, y: -1 }
};

export default function fabricCanvasReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_WALL_CANVAS:
      return {
        ...state,
        wallCanvas: action.payload.wallCanvas
      };
    case actions.SET_ROOM_CANVAS:
      return {
        ...state,
        roomCanvas: action.payload.roomCanvas
      };
    case actions.SET_BOTTOM_BAR_STATUS:
      return { ...state, bottomBarStatus: action.payload };
    case actions.UPDATE_WINDOW_DIMENSIONS:
      return {
        ...state,
        dimensions: {
          ...state.dimensions,
          orgWindowWidth: action.payload.orgWindowWidth,
          orgWindowHeight: action.payload.orgWindowHeight,
          windowWidth: action.payload.windowWidth,
          windowHeight: action.payload.windowHeight,
          canvasWallScaleWidth: action.payload.canvasWallScaleWidth,
          canvasWallScaleHeight: action.payload.canvasWallScaleHeight,
          projectScaleWidth: action.payload.projectScaleWidth,
          projectScaleHeight: action.payload.projectScaleHeight
        }
      };
    case actions.SET_ACTIVE_SELECTION:
      return {
        ...state,
        activeSelection: action.payload.activeSelection
      };
    case actions.SET_ACTIVE_OBJECT:
      return { ...state, activeObject: action.payload.activeObject };
    case actions.UPDATE_ACTIVE_OBJECT_COLORS:
      console.log('action.payload.newColors', action.payload.newColors);
      return {
        ...state,
        activeObject: {
          ...state.activeObject,
          placing: {
            ...state.activeObject.placing,
            placeable: {
              ...state.activeObject.placing.placeable,
              colors: [...action.payload.newColors]
            }
          }
        }
      };
    case actions.SET_PREVIOUS_ACTIVE_OBJECT:
      return {
        ...state,
        previousActiveObject: action.payload.previousActiveObject
      };
    case actions.UPDATE_ROTATE_MODAL:
      return { ...state, rotateModalValue: action.payload.value };
    case actions.UPDATE_DRAGGING_MODAL:
      return { ...state, draggableModalPosition: action.payload.value };
    case actions.UPDATE_SCALAR_MODAL:
      return { ...state, scalarModalValue: action.payload.value };
    case actions.UPDATE_TRANSPARENCY_MODAL:
      return { ...state, transparencyModalValue: action.payload.value };
    case actions.SET_SAVE_STATE:
      return {
        ...state,
        loadingState: action.payload.loadingState,
        loadingCount: action.payload.loadingCount
      };
    case actions.SET_DRAGGED_POSITION:
      return {
        ...state,
        draggedPosition: action.payload.draggedPosition
      };
    case actions.SET_SHOW_PIXELATION_WARNING_FIELD:
      return {
        ...state,
        showPixelationWarningField: action.payload.showPixelationWarningField
      };
    case actions.UPDATE_NON_PIXELATED_DIMENION:
      return {
        ...state,
        nonPixelatedDimension: action.payload.value
      };
    case actions.SET_INITIAL_PIXELATION_DIALOG_SHOWN:
      return {
        ...state,
        setInitialPixelationShown: true
      };
    case actions.SHOW_PIXELATION_WINDOW_DIALOGUE:
      return {
        ...state,
        showPixelationWindowDialogue:
          action.payload.showPixelationWindowDialogue
      };
    case actions.SHOW_REQUEST_SAMPLE_WINDOW:
      return {
        ...state,
        showRequestSampleWindow: action.payload.showRequestSampleWindow
      };
    case actions.HELP_WINDOW_STATUS:
      return {
        ...state,
        helpWindowIsVisible: action.payload.value
      };
    case actions.HELP_CHECKBOX:
      return {
        ...state,
        handleHelpCheckBox: action.payload.value
      };

    case actions.SHOW_ORDER_SAMPLE_DETAILS_WINDOW:
      return {
        ...state,
        showOrderSampleDetailsWindow:
          action.payload.showOrderSampleDetailsWindow
      };
    case actions.SET_ORDER_SAMPLE_DETAILS:
      return {
        ...state,
        orderSampleDetails: action.payload.orderSampleDetails
      };
    case actions.SET_SEND_PREVIEW_WITH_LOUPE:
      return {
        ...state,
        sendPreviewWithLoupe: action.payload.sendPreviewWithLoupe
      };
    case actions.SET_SELECTED_TOOL:
      return {
        ...state,
        selectedTool: action.payload.selectedTool
      };
    case actions.SET_FILTERED_TOOLS:
      return {
        ...state,
        filteredTools: action.payload.filteredTools
      };
    case actions.SET_SHARE_LINK_TYPE:
      return {
        ...state,
        shareLinkType: action.payload.shareLinkType
      };
    case actions.SET_GROUP_PROPERTY:
      return {
        ...state,
        isGrouped: action.payload.isGrouped
      };
    case actions.SET_WEB_LINK_SAVE:
      return {
        ...state,
        webLinkSaveDialogue: action.payload.webLinkSaveDialogue
      };
    case actions.SET_FOLDER_FOR_WEB_LINK:
      return {
        ...state,
        selectedFolderForWebLink: action.payload.selectedFolderForWebLink
      };
    case actions.SET_WEB_USER_INFO:
      return {
        ...state,
        webUserInfo: action.payload.webUserInfo
      };
    case actions.SET_SHOW_VANILLA_LOGIN_DIALOGUE:
      return {
        ...state,
        vanillaLoginIsOpen: action.payload.vanillaLoginIsOpen
      };
    case actions.SET_ALL_EXTERNAL_PROJECTS:
      return {
        ...state,
        allExternalProjects: action.payload.allExternalProjects
      };
    case actions.SET_DIALOGUE_PARAMS:
      return {
        ...state,
        dialogueParams: {
          ...state.dialogueParams,
          dialogueTitle: action.payload.info.header,
          dialoagTitleIcon: action.payload.info.headerIcon,
          dialogueDescription: action.payload.info.description,
          color: action.payload.info.stringColor,
          onclick: action.payload.info.onclick,
          onCancel: action.payload.info.onCancel,
          buttonTitles: action.payload.info.buttonTitles
        }
      };
    case actions.SET_DIALOGUE_FLAG:
      return {
        ...state,
        dialogueParams: {
          ...state.dialogueParams,
          dialogueFlag: action.payload.dialogueFlag
        }
      };
    case actions.MAKE_PROJECT_DIRTY:
      return {
        ...state,
        triggerProjectDirty: action.payload.value
      };

    case actions.MAKE_PROJECT_DIRTY_WITH_NO_UNDO_SUPPORT:
      return {
        ...state,
        makeProjectDirtyWithNoUndoSupport: action.payload.value
      };

    case actions.SET_WB_LINK_SAVE_FOLDER_TYPE:
      return {
        ...state,
        webLinkSaveFolderType: action.payload.webLinkSaveFolderType
      };
    case actions.SET_ROOT_FOLDERS:
      return {
        ...state,
        rootFolders: action.payload.rootFolders
      };
    case actions.SET_WEB_LINK_FIRST_SAVE:
      return {
        ...state,
        isWebLinkFirstSave: action.payload.isWebLinkFirstSave
      };
    case actions.SET_WEB_LINK_SAVE_IDENTIFIER:
      return {
        ...state,
        webLinkSaveIdentifier: action.payload.webLinkSaveIdentifier
      };
    case actions.SET_SHARE_MEDIUM:
      return {
        ...state,
        shareMedium: action.payload.shareMedium
      };
    case actions.SET_IFRAME:
      return {
        ...state,
        showIframe: action.payload.showIframe
      };
    case actions.SET_DEFAULT_MASK_STEP_FOR_ORDER_SAMPLE:
      return {
        ...state,
        defaultMaskStepForOrderSample:
          action.payload.defaultMaskStepForOrderSample
      };
    case actions.SET_SELECTED_OBJECTS:
      return { ...state, selectedObjects: action.payload.selectedObjects };
    case actions.RERENDER_FLAG:
      return {
        ...state,
        renderFlag: !state.renderFlag
      };
    case actions.REDRAW_CANVAS:
      return {
        ...state,
        redrawCanvas: !state.redrawCanvas
      };
    case actions.SET_FEEDBACK_DIALOGUE:
      return {
        ...state,
        showFeedbackDialogue: action.payload.showFeedbackDialogue
      };
    case actions.SET_FEEDBACK_STATE:
      return {
        ...state,
        feedbackState: action.payload.feedbackState
      };
    case actions.UPDATE_TOOL_DRAG_MODAL:
      return { ...state, draggableToolPosition: action.payload.value };

    case actions.SET_PROJECT_SUBMISSION_STATE:
      return {
        ...state,
        projectSubmissionState: action.payload.projectSubmissionState
      };
    case actions.ZOOM_IN_MODE:
      return {
        ...state,
        zoomInState: action.payload.value
      };
    case actions.ZOOM_OUT_MODE:
      return {
        ...state,
        zoomOutState: action.payload.value
      };
    case actions.SET_VIEW_TYPE:
      return {
        ...state,
        viewType: action.payload.value
      };
    case actions.SET_IS_3D_VIEW_LOADED:
      return {
        ...state,
        is3DViewLoaded: action.payload.is3DViewLoaded
      };
    case actions.SET_INITIAL_LOADER:
      return {
        ...state,
        initialLoader: action.payload.initialLoader
      };
    case actions.REFRESH_3D:
      return {
        ...state,
        refresh3D: !state.refresh3D
      };
    case actions.SET_FEEDBACK_RATING:
      return {
        ...state,
        feedbackRating: action.payload.feedbackRating
      };
    case actions.SET_FEEDBACK_REVIEW:
      return {
        ...state,
        feedbackReview: action.payload.feedbackReview
      };
    case actions.SET_FEEDBACK_PERMISSION_STATE:
      return {
        ...state,
        feedbackPermission: action.payload.feedbackPermission
      };
    case actions.SET_SVG_REFERENCE_ID:
      return {
        ...state,
        svgReferenceId: action.payload.svgReferenceId
      };
    case actions.SEND_REVIEW_ORDER_GA:
      return {
        ...state,
        sendReviewGA: action.payload.sendReviewGA
      };
    case actions.BLOCKCHAIN_TRANSACTION_IN_PROGRESS:
      return {
        ...state,
        blockChainTransactionInProgress:
          action.payload.blockChainTransactionInProgress
      };
    case actions.TEMPLATE_SELECTION_DIALOGUE:
      return {
        ...state,
        showTemplateSelectionDialogue:
          action.payload.showTemplateSelectionDialogue,
        dataPriorToTemplateSelection: action.payload.backupData
      };
    case actions.SET_SAVE_VIA_WALL_NAVIGATION:
      return {
        ...state,
        isSaveViaWallNavigation: action.payload.isSaveViaWallNavigation
      };
    case actions.SET_SHARED_SCENE_DATA:
      return {
        ...state,
        sharedSceneData: {
          ...state.sharedSceneData,
          sharedScenePlacing: action.payload.sharedSceneData.placing,
          sharedSceneProjectIndex: action.payload.sharedSceneData.projectIndex
        }
      };
    case actions.SET_PROJECT_GROUP_SHARED_SCENE:
      return {
        ...state,
        projectGroupSharedScene: action.payload.projectGroupSharedScene
      };
    case actions.SET_DRAGGABLE_CANVAS_POSITION:
      return {
        ...state,
        draggableCanvasPosition: {
          ...state.draggableCanvasPosition,
          x: action.payload.x,
          y: action.payload.y
        }
      };

    default:
      return state;
  }
}
